import styled from 'styled-components/macro'
import { media } from '../../utils/styles'

const HeaderCentered = styled.div`
  line-height: 0;

  ${media('tablet')`
    text-align: center;
    width: 100%;
  `}
`

export default HeaderCentered
